import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { userApi, spreedlyCredentialsApi, spreedlyCredentialsApiMiddleware, vibesApi, lifestyleEligibilityApi } from "@capone/common";
import { rootSaga } from "../sagas";
import { B2bBaseState, rootReducer } from "./reducers";

// REDUX SAGA middleware
export const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: combineReducers({
    rootReducer,
    [vibesApi.reducerPath]: vibesApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [spreedlyCredentialsApi.reducerPath]: spreedlyCredentialsApi.reducer,
    [lifestyleEligibilityApi.reducerPath]: lifestyleEligibilityApi.reducer,
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      sagaMiddleware,
      vibesApi.middleware,
      userApi.middleware,
      spreedlyCredentialsApiMiddleware,
      lifestyleEligibilityApi.middleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

sagaMiddleware.run(rootSaga);

export interface IStoreState {
  rootReducer: B2bBaseState;
}
